import React from 'react';
import BaseField, { BaseFieldProps } from '../BaseField/BaseField';
import ImageFileUpload from './ImageFileUpload';

const ImageFileUploadField: React.FC<BaseFieldProps> = props => {
	return (
		<BaseField {...props}>
			<ImageFileUpload />
		</BaseField>
	);
};

export default ImageFileUploadField;
